import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const DownlinesSummaryApi = {
  getSummary: async (userId) => {
    try {
      // GET request with user_id as query parameter
      const response = await axiosInstance.get(
        `${Configs.downlinesSummaryEp}`,
        {
          params: { user_id: userId },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Failed to load downlines summary:", error);
      return {
        status: "fail",
        data: error.message,
      };
    }
  },
};

export default DownlinesSummaryApi;
